import { If } from "components";
import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { Pagination } from "ui";

import { useGetProductComments } from "../../apis";
import { ProductCommentItemCard } from "../../components";

import styles from "./ProductComments.module.scss";

const ProductComments = () => {
  const { t } = useTranslation();
  const { productId } = useParams();
  const { page, setPage } = useManageTable();

  const { comments, isLoading, meta, refetch } = useGetProductComments({
    productId: String(productId),
    page,
    take: GET_LIST_REQUEST_DEFAULT_LIMIT
  });

  return (
    <div className={styles.comments}>
      <div>
        <If condition={isLoading}>
          <div className={styles.comments_loader}>
            <ClipLoader size={50} color="#fb3973" />
          </div>
        </If>

        <If condition={comments && comments.length === 0}>
          <p className={styles.comments_emptyListMessage}>
            {t("There are no comments on this product")}
          </p>
        </If>

        {comments?.map((comment) => (
          <ProductCommentItemCard
            key={comment.id}
            item={comment}
            refetch={refetch}
          />
        ))}
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        totalItems={meta?.itemCount}
      />
    </div>
  );
};

export default ProductComments;
